import { React, models, kea, history, resources, selectores, componentToRx, Route } from "app/main/std";
import { fa } from "typed-font-awesome";

type Entity = models.Vendedor;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Nombre", cell: x => ({ data: x.Nombre }) }
];

export interface BotonesDeps {
    onBorrar: (item: Entity) => void;
}

function botones(deps: BotonesDeps): kea.Grid2Column<Entity, undefined> {
    const columna = kea.columnaBotones<Entity>([ 
        {
            tooltip: "Eliminar",
            style: "danger",
            iconClass: fa("trash"),
            onClick: deps.onBorrar
        }
    ]); 
    return columna;
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps): kea.Grid2Column<Entity, undefined>[] {
    return [botones(deps), ...columnasFijas];
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/usuarios/edit/columns.tsx